export default __webpack_public_path__ + "static/char-15-f5eda300e202a754af291b7a002a0a29.webp";